import React from "react";
import ContactUs from "./ContactUs";
import PriceRequestForm from "./PriceRequestForm";
import Footer from "../../../components/footer/Footer";
import ContactMap from "./templates/ContactMap";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import ContactCard from "./templates/ContactCard";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import PageTitleCard from "../../templates/PageTitleCard";
import PageHeading from "../../../templates/PageHeading";
import SubHeadingText from "../../../common/SubHeadingText";
import RightArrow from "../../../templates/RightArrow";
import CurrentPath from "../../../templates/CurrentPath";
import BackHome from "../../../templates/BackHome";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Contact = () => {
  const { data, isLoading } = useQuery({
    queryKey: "getContact",
    queryFn: () =>
      axios.get(`${BASEURL}contacts`).then((res) => {
        return res?.data;
      }),
  });

  return (
    <>
      <PageTitleCard>
        <PageHeading>Contact</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Contact</CurrentPath>
        </div>
      </PageTitleCard>

      <div className="container mx-auto py-8 max-sm:px-8 ">
        <SubHeadingText>Contact us</SubHeadingText>
        <div className="py-8">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-10">
            {isLoading ? (
              Array.from({ length: 4 }).map((_, i) => (
                <Skeleton className="w-full h-48" key={i} />
              ))
            ) : (
              <>
                <ContactCard
                  icon={<FaLocationDot />}
                  title="Our Main Office"
                  para={data?.address}
                />
                <ContactCard
                  icon={<FaPhone />}
                  title="Phone Number"
                  para={data?.phone}
                />
                <ContactCard
                  icon={<IoIosMail />}
                  title="Email"
                  para={data?.email}
                />
                <ContactCard
                  icon={<MdOutlineAccessTimeFilled />}
                  title="Business Hours"
                  para={data?.working_hours}
                />
              </>
            )}
          </div>
          <div className="grid lg:grid-cols-2   gap-5 py-10  ">
            <div className="lg:block md:hidden sm:hidden max-sm:hidden">
              <PriceRequestForm />
            </div>
            <ContactMap />
            <div className="lg:hidden md:block sm:block max-sm:block">
              <PriceRequestForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
